export default {"src":"/_next/static/media/roadmap4.75f0d208.svg","height":39,"width":39};